import React from 'react'
const ThumbUpIcon = ({ active = false }) => (
  <svg
    width="21"
    height="20"
    viewBox="0 0 21 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M16 20H5V7L12 0L13.25 1.25C13.3667 1.36667 13.4625 1.525 13.5375 1.725C13.6125 1.925 13.65 2.11667 13.65 2.3V2.65L12.55 7H19C19.5333 7 20 7.2 20.4 7.6C20.8 8 21 8.46667 21 9V11C21 11.1167 20.9833 11.2417 20.95 11.375C20.9167 11.5083 20.8833 11.6333 20.85 11.75L17.85 18.8C17.7 19.1333 17.45 19.4167 17.1 19.65C16.75 19.8833 16.3833 20 16 20ZM7 18H16L19 11V9H10L11.35 3.5L7 7.85V18ZM5 7V9H2V18H5V20H0V7H5Z"
      fill={active ? '#1A2547' : '#A7A7C2'}
    />
  </svg>
)

export default ThumbUpIcon
